import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { View, Image } from '@zhike/ti-ui';
import { get, findIndex } from 'lodash';
import { cdnUrl } from 'common/config';
import soundBuffer from '../audioCtx/soundBuffer';
import styles from './styles';

const loopData = [
  { num: -1, name: '无限循环' },
  { num: 4, name: '循环5次' },
  { num: 2, name: '循环3次' },
  { num: 1, name: '循环2次' },
  { num: 0, name: '循环1次' },
];
// const speedData = [
//   1.5,
//   1.2,
//   1.0,
//   0.8,
// ];
const loopImage = [
  require('./assets/loop.png'),
  require('./assets/loop_5.png'),
  require('./assets/loop_3.png'),
  require('./assets/loop_2.png'),
  require('./assets/loop_1.png'),
];

export default class Audio extends Component {
  // 参数
  static propTypes = {
    src: PropTypes.string.isRequired,
    progressWidth: PropTypes.number,
    setSentenceIndex: PropTypes.func,
    hiddenWelcome: PropTypes.func,
    handleNext: PropTypes.func,
    handlePrev: PropTypes.func,
    handleClickRaw: PropTypes.func,
    getPlaying: PropTypes.func,
    handleRepeat: PropTypes.func,
    clickRawNum: PropTypes.number,
    isFullText: PropTypes.number.isRequired,
    sentenceIndex: PropTypes.number.isRequired,
    translation: PropTypes.array.isRequired,
    handleCompleted: PropTypes.func.isRequired, // 音频转化完通知父组件
  };

  static defaultProps = {
    progressWidth: 524,
    setSentenceIndex: () => {},
    hiddenWelcome: () => {},
    handleNext: () => {},
    handlePrev: () => {},
    handleClickRaw: () => {},
    getPlaying: () => {},
    handleRepeat: () => {},
    clickRawNum: 0,
  };

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
      duration: 0,
      progress: 0,
      volume: 1,
      isShowVolume: false,
      loopIndex: 4,
      loopNum: 0,
      isShowLoop: false,
      // speed: 1.0,
      isShowSpeed: false,
      isLoad: true,
      switchTo: -1, // 在无限循环的时候，切换到其他循环时使用
    };
    this.isTry = 0;
    this.first = true;
    this.startTime = 0;
    this.isAccuracy = false; // 全文切换的时候 有点击进度条和 点击模块两种情况
    this.manualSwitch = false; // 全文切换时, 是否为用户手动切换，区分正常切换（音频不暂停）
    this.isTimeOut = false; // 循环播放时 间隔暂停状态 禁止用户点击
  }

  componentDidMount() {
    this.setAudio(this.props.src);
  }

  // 模块接受参数
  componentWillReceiveProps(nextProps) {
    if (this.props.src !== nextProps.src) {
      this.destroyAudio();
      this.stopUpdateProgress();
      this.isTry = 0;
      this.setAudio(nextProps.src);
    }
    // 监听全文和单句的切换
    if (this.props.isFullText !== nextProps.isFullText) {
      const { translation } = nextProps;
      const { start, end } = translation[nextProps.sentenceIndex] || {};
      this.destroyAudio();
      this.stopUpdateProgress();
      if (!nextProps.isFullText) {
        console.log('从全文切换成单句');
        this.setState({
          playing: false,
          duration: end - start,
          progress: 0,
        });
      } else {
        console.log('从单句切换成全文');
        this.setState({
          playing: false,
          duration: get(this, 'soundBuf.duration') || 0,
          progress: 0,
        });
      }
      return false;
    }
    // 监听sentenceIndex 的变动
    if (this.props.sentenceIndex !== nextProps.sentenceIndex) {
      const { duration, playing, progress } = this.state;
      const { translation, isFullText } = nextProps;
      const { start, end } = translation[nextProps.sentenceIndex] || {};
      this.sound && (!isFullText || (!this.manualSwitch && isFullText)) && this.destroyAudio();
      if (isFullText) {
        let startTime = progress * duration / 100;
        if (this.props.clickRawNum !== nextProps.clickRawNum && !this.isAccuracy) {
          startTime = start;
          this.setState({
            progress: (start / duration) * 100,
          });
        } else {
          this.isAccuracy = false;
        }
        playing && !this.manualSwitch && isFullText === 1 && this.play(startTime, duration, isFullText);
        this.manualSwitch = false;
      } else {
        // 重置loop次数
        const { loopIndex } = this.state;
        const loopNum = loopData[loopIndex].num;
        this.setState({
          loopNum,
          duration: end - start,
          progress: 0,
        });
        if (!this.progressInterval) {
          this.updateProgress();
        }
        if (!playing) {
          this.props.getPlaying(true);
          this.setState({ playing: true })
        }
        this.play(start, end, isFullText, loopNum);
      }
    }
  }

  componentWillUnmount() {
    this.destroyAudio();
    this.stopUpdateProgress();
  }

  // 圆点onTouchStart
  onTouchStart = e => {
    console.log(e, 'start');
  }

  // 圆点onTouchMove
  onTouchMove = e => {
    console.log(e, 'move');
  }

  // 圆点onTouchEnd
  onTouchEnd = e => {
    console.log(e, 'end');
  }
  // 返回完整路径
  completePath(url) {
    if (url.indexOf('http') !== -1) return url;
    return `${cdnUrl}/${url}`;
  }
  // 创建音频
  setAudio = src => {
    soundBuffer.getBuffer(this.completePath(src)) // eslint-disable-line
      .then(buf => {
        this.soundBuf = buf; // 存储，方便调用
        this.setState({
          isLoad: false,
          duration: this.soundBuf.duration,
        });
        this.props.handleCompleted();
      })
      .catch(e => {
        console.log(e);
      });
    this.setState({
      playing: false,
      progress: 0,
      isLoad: true,
      isShowVolume: false,
      loopIndex: 4,
      loopNum: 0,
      isShowLoop: false,
      // speed: 1.0,
      isShowSpeed: false,
    });
  }

  // 销毁音频
  destroyAudio() {
    if (this.sound) {
      this.sound.stop();
      this.sound.onended = () => {};
      this.sound.loop = false;
      this.sound = null;
      const { loopIndex } = this.state;
      const loopNum = loopData[loopIndex].num;
      this.setState({ loopNum });
      this.isTimeOut = false;
    }
  }

  // 报错信息
  handleError = () => {
    if (this.isTry < 2) {
      setTimeout(() => {
        if (!this.audio) return false;
        const oldSrc = this.audio.src;
        this.destroyAudio();
        this.setAudio(oldSrc);
      }, 2000);
      this.isTry += 1;
    }
  }

  // 处理时间
  timeFormat(times, isCeil = false) {
    let day = 0;
    let hour = 0;
    let minute = 0;
    let seconds = 0;
    let newTimes = times;
    if (newTimes > 0) {
      day = Math.floor(times / (60 * 60 * 24));
      hour = Math.floor(times / (60 * 60)) - (day * 24);
      minute = Math.floor(times / 60) - (day * 24 * 60) - (hour * 60);
      seconds = Math.floor(times) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
    }

    if (minute <= 9) minute = `0${minute}`;
    if (seconds <= 9) seconds = `0${seconds}`;
    if (seconds < 1 && isCeil) seconds = '01';
    newTimes = `${minute}:${seconds}`;

    return newTimes;
  }

  // 播放音频
  audioStart = (repeat = false) => {
    const { translation, isFullText, sentenceIndex } = this.props;
    const { start, end } = translation[sentenceIndex] || {};
    const { progress, duration } = this.state;
    if (!this.progressInterval) {
      this.updateProgress();
    }
    // soundBuffer 不能调用两次start(), 只能销毁后重新创建
    if (!this.sound) {
      let startTime = progress * duration / 100;
      if (isFullText && sentenceIndex === translation.length - 1 && progress === 100) {
        this.setState({ progress: 0 });
        if (!repeat) this.props.setSentenceIndex(0);
      } else if (isFullText && progress === 0 && sentenceIndex === 0) {
        this.play(0, duration, isFullText);
      } else if (!isFullText) {
        if (progress === 100) {
          this.setState({ progress: 0 });
          startTime = start;
        } else {
          startTime = start + progress * duration / 100;
        }
        this.play(startTime, end, isFullText);
      } else {
        this.play(startTime, duration, isFullText);
      }
    }
    this.props.getPlaying(true);
    this.setState({ playing: true })
  }

  // 暂停播放
  audioPause = () => {
    this.stopUpdateProgress();
    this.destroyAudio();
    this.props.getPlaying(false);
    this.setState({ playing: false })
  }

  // 音频播放
  play = (start, end, isFullText, loopNum = this.state.loopNum) => {
    const { translation } = this.props;
    const { volume, playing, duration, switchTo } = this.state;
    this.startTime = soundBuffer.getCurrentTime();
    if (!this.progressInterval && playing) {
      this.updateProgress();
    }
    if (this.first) {
      this.props.hiddenWelcome();
      this.first = false;
    }
    // 使用 AudioBufferSourceNode 不能重复调用 start， 需要销毁之后再次调用
    this.sound = soundBuffer.createSound(this.soundBuf);
    let startTime = start;
    if (!isFullText) startTime = start < translation[0].start ? translation[0].start : start;
    this.sound.start(0, startTime, isFullText ? duration : end - start);
    soundBuffer.setVolume(volume);
    this.sound.onended = () => {
      if (!isFullText) {
        this.stopUpdateProgress();
        this.props.getPlaying(false);
        this.setState({ playing: false, progress: 100 });
        if (loopNum !== 0) {
          if (switchTo !== -1 && loopNum === -1) {
            this.setState({ loopNum: switchTo });
            return false;
          }
          this.isTimeOut = true;
          this.setState({ progress: 0, loopNum: loopNum < 0 ? -1 : loopNum - 1 });
          setTimeout(() => {
            this.isTimeOut = false;
            this.audioStart();
          }, 2000);
        } else if (loopNum === 0) {
          const { loopIndex } = this.state;
          const loopNum = loopData[loopIndex].num;
          this.setState({ loopNum });
        }
      } else if (isFullText) {
        this.stopUpdateProgress();
        this.props.getPlaying(false);
        this.setState({ playing: false, progress: 0 });
      }
      this.destroyAudio();
    }
  }

  // 点击播放
  handleClickPlay = () => {
    if (this.isTimeOut) return false;
    if (!this.state.playing) {
      this.audioStart();
    } else {
      this.audioPause();
    }
  }

  // 进度条更新
  updateProgress = () => {
    this.progressInterval = setInterval(() => {
      const { progress, duration } = this.state;
      const { translation, sentenceIndex, isFullText } = this.props
      const newProgress = (soundBuffer.getCurrentTime() - this.startTime) * 100 / duration + progress;
      this.setState({
        progress: newProgress,
      });
      this.startTime = soundBuffer.getCurrentTime();
      // 判断播放的段落是否是 当前 sentenceIndex
      if (isFullText) {
        const startTime = newProgress * duration / 100 < translation[0].start ? translation[0].start : newProgress * duration / 100;
        const currentIndex = findIndex(translation, item => startTime >= item.start && startTime < item.end);
        if (currentIndex !== sentenceIndex) {
          this.manualSwitch = true;
          this.props.setSentenceIndex(currentIndex);
        }
      }
    }, 100);
  }

  // 停止更新进度条
  stopUpdateProgress = () => {
    clearInterval(this.progressInterval);
    this.progressInterval = null;
  }

  // 点击进度条
  handleClickProgress = e => {
    this.destroyAudio();
    this.stopUpdateProgress();
    const { duration, playing } = this.state;
    const { progressWidth, isFullText, translation, sentenceIndex } = this.props;
    const newCurrentTime = e.nativeEvent.offsetX / progressWidth * duration;
    const { start } = translation[sentenceIndex] || {};
    let startTime = 0;
    if (isFullText) {
      startTime = newCurrentTime;
    } else {
      startTime = start + newCurrentTime
    }
    // 进度条控制音频 是通过progress 来计算startTime的，所以要放在回调函数中
    this.setState({
      progress: newCurrentTime / duration * 100,
    }, () => {
      const end = isFullText ? duration : translation[sentenceIndex].end;
      // 判断播放的段落是否是 当前 sentenceIndex
      const currentIndex = findIndex(translation, item => startTime >= item.start && startTime < item.end);
      if (currentIndex !== sentenceIndex) {
        this.isAccuracy = true;
        this.props.setSentenceIndex(currentIndex);
      } else if (playing) {
        this.play(startTime, end, isFullText);
      }
    });
  }

  // 调整音量
  handelVolume(status, event) {
    if (status === 'start') {
      global.window.onmouseup = () => this.handelVolume('end');
      global.window.onmousemove = event => this.handelVolume('adjust', event);
    }
    if (status === 'end') {
      global.window.onmouseup = undefined;
      global.window.onmousemove = undefined;
    }
    if (status === 'adjust') {
      const processBar =
        /* eslint-disable */
        ReactDOM.findDOMNode(this.volumeProcessBar).getBoundingClientRect();
        /* eslint-enable */
      const offset = event.y - (processBar.y || processBar.top);
      const volume = Math.max(Math.min(offset / processBar.height, 1), 0);
      if (this.sound) soundBuffer.setVolume(1 - volume);
      this.setState({
        volume: 1 - volume,
      });
    }
  }

  // 处理快进3秒/快退3秒
  handelForwardBackward(isForward) {
    if (!this.state.playing) return false;
    const { isFullText, translation, sentenceIndex } = this.props;
    const { start, end } = translation[sentenceIndex] || {};
    const { progress, duration } = this.state;
    this.destroyAudio();
    let newProgress = progress;
    if (isForward ? progress === 100 : progress === 0) return false;
    if (isForward ? progress * duration / 100 + 3 < duration : progress * duration / 100 - 3 > 0) {
      newProgress = isForward ? progress + 300 / duration : progress - 300 / duration;
    } else {
      newProgress = isForward ? 100 : 0;
    }
    const offsetTime = newProgress * duration / 100;
    const startTime = isFullText ? (offsetTime >= duration ? duration : offsetTime)
      : (start + offsetTime >= end ? end - 0.01 : start + offsetTime);
    this.setState({
      progress: newProgress,
    });
    if (isFullText) {
      this.play(startTime, duration, isFullText);
    } else {
      this.play(startTime, end, isFullText);
    }
  }
  // 重读当前句
  handelRepeat() {
    this.destroyAudio();
    this.stopUpdateProgress();
    const { translation, isFullText } = this.props;
    const { duration } = this.state
    const { start } = translation[this.props.sentenceIndex] || {};
    if (isFullText) {
      this.setState({ progress: (start / duration) * 100 });
    } else {
      this.setState({ progress: 0 });
    }
    this.audioStart(true);
  }

  render() {
    const { playing, progress, duration, loopIndex,
      volume, isLoad, isShowVolume, isShowLoop, isShowSpeed } = this.state;
    const { progressWidth, sentenceIndex, translation, isFullText } = this.props;
    const playClass = [styles.default];
    playing ? playClass.push(styles.pause) : playClass.push(styles.play);
    const blueWidth = progressWidth * progress / 100;
    const currentTime = duration * progress / 100;
    return (
      <View className={styles.container}>
        <View className={styles.audioBox}>
          <View
            className={[styles.defaultSmall, styles.playPrev, sentenceIndex === 0 && styles.disable]}
            onClick={() => {
              this.props.handlePrev();
              }
            }
          />
          <View
            className={[styles.defaultSmall, styles.backward]}
            onClick={() => this.handelForwardBackward(false)}
          />
          <View
            className={[playClass, this.isTimeOut && styles.disable]}
            onClick={this.handleClickPlay}
          />
          <View
            className={[styles.defaultSmall, styles.forward]}
            onClick={() => this.handelForwardBackward(true)}
          />
          <View
            className={[styles.defaultSmall, styles.playNext, sentenceIndex === (translation.length - 1) && styles.disable]}
            onClick={() => {
              this.props.handleNext()
            }}
          />
          <View className={styles.audioTime}>
            { this.timeFormat(currentTime.toFixed(2)) }
          </View>
          <View className={styles.progressBox} style={{ width: `${progressWidth}px` }}>
            <View className={styles.progress} onClick={this.handleClickProgress}>
              <View className={styles.blueProgress} style={{ width: `${blueWidth}px` }} />
            </View>
            <View
              className={styles.dot}
              style={{ left: `${blueWidth - 6}px` }}
              onTouchStart={this.onTouchStart}
              onTouchMove={this.onTouchMove}
              onTouchEnd={this.onTouchEnd}
            />
          </View>
          <View className={styles.audioTime}>{this.timeFormat(duration.toFixed(2))}</View>
          {
            (isShowVolume || isShowLoop || isShowSpeed) &&
            <View
              className={styles.fullMask}
              onClick={() => {
                this.setState({
                  isShowVolume: false,
                  isShowLoop: false,
                  isShowSpeed: false,
                });
              }}
            />
          }
          <View
            className={styles.IconWrapper}
            onClick={() => {
              this.setState({ isShowVolume: true });
            }}
          >
            <Image className={styles.audioIcon} src={require('./assets/voice.png')} />
            {
              isShowVolume &&
              <View className={styles.volumeBox}>
                <View
                  ref={
                    volumeProcessBar => {
                      this.volumeProcessBar = volumeProcessBar;
                    }
                  }
                  className={styles.volumeProcessBarWrapper}
                >
                  <View
                    className={styles.volumeProcessBar}
                    style={{ height: 80 - (volume * 80) }}
                  />
                  <View
                    className={styles.volumeProcessCircle}
                    style={{ bottom: volume * 80 - 4 }}
                    onMouseDown={() => this.handelVolume('start')}
                  />
                </View>
                <View className={styles.grayTriangle} />
                <View className={styles.whiteTriangle} />
              </View>
            }
          </View>
          <View
            className={[styles.IconWrapper, isFullText && styles.disable]}
            onClick={() => {
              if (!isFullText) this.setState({ isShowLoop: true });
            }}
          >
            <Image
              className={styles.audioIcon}
              src={loopImage[loopIndex]}
            />
            {
              isShowLoop &&
              <View className={styles.loopBox}>
                {
                  loopData.map((item, index) =>
                    (
                      <View
                        key={index}
                        className={styles.loopText}
                        onClick={e => {
                          e.stopPropagation();
                          this.setState({
                            loopIndex: index,
                            loopNum: item.num,
                            switchTo: item.num === -1 ? -1 : item.num,
                            isShowVolume: false,
                            isShowLoop: false,
                            isShowSpeed: false,
                          });
                          }
                        }
                      >
                        {item.name}
                      </View>))
                }
                <View className={[styles.grayTriangle, styles.loopTriangle]} />
                <View className={[styles.whiteTriangle, styles.loopTriangle]} />
              </View>
            }
          </View>
          {/* <View
            className={[styles.IconWrapper, styles.speedWrapper]}
            onClick={() => {
              this.setState({ isShowSpeed: true });
            }}
          >
            {`x${speed.toFixed(1)}`}
            {
              isShowSpeed &&
              <View className={styles.speedBox}>
                {
                  speedData.map((item, index) =>
                    (
                      <View
                        key={index}
                        className={styles.loopText}
                        onClick={e => {
                          e.stopPropagation();
                          if (this.audio) this.audio.playbackRate = item;
                          this.setState({
                            speed: item,
                            isShowVolume: false,
                            isShowLoop: false,
                            isShowSpeed: false,
                          });
                          }
                        }
                      >
                        {`x${item.toFixed(1)}`}
                      </View>))
                }
                <View className={[styles.grayTriangle, styles.loopTriangle]} />
                <View className={[styles.whiteTriangle, styles.loopTriangle]} />
              </View>
            }
          </View> */}
          {
            isLoad && this.isTry < 2 &&
              <View className={styles.mask}>
                <View className={styles.spot} />
                <View className={styles.spot} />
                <View className={styles.spot} />
              </View>
          }
          {
            isLoad && this.isTry === 2 &&
            <View className={styles.maskError}>
              <View>音频加载失败，请刷新重试</View>
            </View>
          }
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/listen/audioCtx/index.js